import { DataSource } from '@angular/cdk/table';
import { Backup } from './backup.model';
import { BackupService } from './backup.service';
import { Observable } from 'rxjs';

export class BackupDataSource extends DataSource<Backup> {
  constructor(private backupService: BackupService, private isStaging: boolean) {
    super();
  }

  connect(): Observable<Backup[]> {
    return this.isStaging ? this.backupService.stagingBackups : this.backupService.backups;
  }

  disconnect(): void {
    return; // so lint is happy
  }
}
